import { render, staticRenderFns } from "./eg_custom_radio.vue?vue&type=template&id=18806890&scoped=true&"
import script from "./eg_custom_radio.vue?vue&type=script&lang=js&"
export * from "./eg_custom_radio.vue?vue&type=script&lang=js&"
import style0 from "./eg_custom_radio.vue?vue&type=style&index=0&id=18806890&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18806890",
  null
  
)

export default component.exports